import { AlertCircle, Inbox, Loader2 } from 'lucide-react';
import { Button } from './Button';
import { cn } from '../../utils/cn';

export interface LoadingStateProps {
  title?: string;
  description?: string;
  className?: string;
}

export function LoadingState({ title = 'Loading', description, className }: LoadingStateProps) {
  return (
    <div className={cn('flex min-h-48 flex-col items-center justify-center gap-3 px-6 text-center', className)}>
      <Loader2 className="h-5 w-5 animate-spin text-academy-500" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-ink-900">{title}</p>
        {description ? <p className="text-sm text-ink-500">{description}</p> : null}
      </div>
    </div>
  );
}

export interface EmptyStateProps {
  title?: string;
  description?: string;
  className?: string;
}

export function EmptyState({ title = 'No results found', description, className }: EmptyStateProps) {
  return (
    <div className={cn('flex min-h-48 flex-col items-center justify-center gap-3 px-6 text-center', className)}>
      <Inbox className="h-5 w-5 text-ink-400" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-ink-900">{title}</p>
        {description ? <p className="text-sm text-ink-500">{description}</p> : null}
      </div>
    </div>
  );
}

export interface ErrorStateProps {
  title?: string;
  description?: string;
  retryLabel?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({
  title = 'Something went wrong',
  description,
  retryLabel = 'Try again',
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div className={cn('flex min-h-48 flex-col items-center justify-center gap-3 px-6 text-center', className)}>
      <AlertCircle className="h-5 w-5 text-danger-600" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-ink-900">{title}</p>
        {description ? <p className="text-sm text-ink-500">{description}</p> : null}
      </div>
      {onRetry ? <Button variant="secondary" size="sm" onClick={onRetry}>{retryLabel}</Button> : null}
    </div>
  );
}
